//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: "Pagination",
	props: {
		page: Number,
		total: Number,
		blogsPerPage: Number,
	},
	computed: {
		totalPages() {
			var pagecount = Math.ceil(this.total / this.blogsPerPage);
			if (isNaN(pagecount)) pagecount = 0;
			return pagecount;
		},
		previousPage() {
			return this.page == 1 ? "" : this.page - 1;
		},
		nextPage() {
			return this.page + 1;
		},
	},
	methods: {
		handleNavClick(e, newPage) {
			if (e.target.matches("[disabled]")) return
			this.$emit('navigate', newPage);
		}
	},
}
